let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ljHtp")).then(() => parcelRequire('9dH6R'));